import { createContext, useContext } from 'react';
import { TemplateType } from '../../common/types';
import { MediumContent } from 'modules/graphql';

export interface TemplateTypeAndLocalesQueryContextState {
  templateType: TemplateType;
  localeContents?: MediumContent[];
}

export const TemplateTypeAndLocalesQueryContext =
  createContext<TemplateTypeAndLocalesQueryContextState>({
    templateType: null,
    localeContents: [],
  });

export const useTemplateTypeAndLocalesQueryContext = () =>
  useContext(TemplateTypeAndLocalesQueryContext);
